import { useSignalEffect } from "@preact/signals";
import { FC } from "preact/compat";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { getMe } from "~/core";
import { getChats } from "~/core/store";
import { ChatPopup } from "~/organisms";
import Header from "./Header";
import Menu from "./Menu";

const Main: FC = () => {
    const { loading, me } = getMe();
    const chats = getChats();
    const location = useLocation();

    useSignalEffect(() => {
        if (me.value && !loading.value) {
            chats.load();
        }
    });

    if (!loading.value && !me.value) {
        return (
            <Navigate
                to={`/p/sign-in?continue=${encodeURIComponent(
                    location.pathname
                )}`}
                replace
            />
        );
    }

    return (
        <div className="w-screen h-screen max-w-screen max-h-screen overflow-hidden flex flex-col text-[#454554]">
            <Header />
            <div className="flex h-full">
                <Menu />
                <div className="w-full">{!loading.value && <Outlet />}</div>
            </div>
            <ChatPopup />
        </div>
    );
};

export default Main;
